/**
 * The workbench's tour keeps its place and the person's tour flags in this browser's storage, under the
 * renderer's own keys (`packages/capturepoint/src/renderer/tour.ts`, `TOUR_STORAGE_KEY` and the flags beside
 * it). They are one person's: the half-finished tour, whether they took or watched it, and the offer of a tour
 * on their own job. Signing out, or another person signing in, forgets them, so the next person on a shared
 * computer is not dropped into the last person's tour or told they took it (gap B14, 2026-10-20). The tour
 * itself resumes on any device from its sample job (`Job.sampleTour.step`), so nothing is lost.
 */
export const tourKeys = [
  'cpv6-demo-tour',
  'cpv6-own-tour-offer',
  'cpv6-tour-taken',
  'cpv6-tour-watched',
  'cpv6-tour-finished',
] as const;

/** Removes the tour's keys; a blocked store has nothing to forget. */
export function forgetTour(
  storage: Pick<Storage, 'removeItem'> | undefined = globalThis.localStorage,
): void {
  for (const key of tourKeys) {
    try {
      storage?.removeItem(key);
    } catch {
      return;
    }
  }
}
